import { graphql } from 'gatsby';

import { ImageSwiper } from '@mewa/ui';

import { imagePopulate } from '../../../../libs/strapi-populates';
import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';
import { StrapiImage } from './image';
import { ImageSlide } from './image-slide';

export const ImageSlideshowFragment = graphql`
  fragment ImageSlideshowFragment on STRAPI__COMPONENT_SHARED_IMAGE_SLIDESHOW {
    strapi_component
    imageSlides {
      ...ImageSlideFragment
    }
  }
`;

export const componentName = 'shared.image-slideshow';

export type ImageSlideshowData = {
  imageSlides: ImageSlide[];
  strapi_component: typeof componentName;
};

export type ImageSlideshowPreview = ImageSlideshowData;

export const isImageSlideshow = (
  component: PossibleContentSections,
): component is ImageSlideshowData => {
  return component.strapi_component === componentName;
};

export const StrapiImageSlideshow = ({
  imageSlides,
}: ComponentProps<ImageSlideshowData>) => {
  const slides = imageSlides.map((slide) => ({
    image: <StrapiImage responsiveImage={slide} />,
    description: slide.title || '',
  }));

  return <ImageSwiper slides={slides} />;
};

export const config = {
  isComponent: isImageSlideshow,
  Component: StrapiImageSlideshow,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  populationParams: { imageSlides: imagePopulate },
  componentName,
  mapProperties: (imageSlideshow): ImageSlideshowData | null =>
    imageSlideshow.strapi_component === componentName ? imageSlideshow : null,
};
